import { MessageBox } from 'element-ui'
import { getUserInfo } from './auth'
import { formatApiError } from './apiError'

export const GROUPON_MAINTENANCE_MESSAGE = '团购核销功能维护中'

export function isPrivilegedAdminUser(user) {
  const u = user || getUserInfo() || {}
  const r = String(u.roleLabel || u.role || '').trim()
  return r === '管理员' || r === '超级管理员' || r === 'admin'
}

export function isGrouponMaintenanceError(errOrMsg) {
  const msg =
    typeof errOrMsg === 'string'
      ? errOrMsg
      : formatApiError(errOrMsg, '') ||
        (errOrMsg &&
          errOrMsg.response &&
          errOrMsg.response.data &&
          errOrMsg.response.data.message) ||
        ''
  return String(msg).includes(GROUPON_MAINTENANCE_MESSAGE)
}

/** 普通账号遇到维护态时弹窗；返回 true 表示已处理 */
export function alertGrouponMaintenanceIfNeeded(errOrMsg) {
  if (!isGrouponMaintenanceError(errOrMsg)) return false
  MessageBox.alert(GROUPON_MAINTENANCE_MESSAGE, '提示', {
    type: 'warning',
    confirmButtonText: '知道了'
  })
  return true
}

export function alertGrouponMaintenance() {
  return MessageBox.alert(GROUPON_MAINTENANCE_MESSAGE, '提示', {
    type: 'warning',
    confirmButtonText: '知道了'
  })
}
